import "../styles/filter-pills.css";
import { Link } from "react-router-dom";


//filters for the browse by section on the home page
const filters = [
  {
    label: "EVs",
    href: "/inventory?fuelType=Electric",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m20.048 11.762-10.5 11.25a.75.75 0 0 1-1.283-.656l1.374-6.875-5.402-2.029a.75.75 0 0 1-.282-1.219l10.5-11.25a.75.75 0 0 1 1.284.657L14.36 8.522l5.402 2.026a.75.75 0 0 1 .282 1.214z" />
      </svg>
    ),
  },
  {
    label: "Lease",
    href: "/financing",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M21 5.25A3.75 3.75 0 0 0 17.25 1.5h-10.5A3.75 3.75 0 0 0 3 5.25v13.5a3.75 3.75 0 0 0 3.75 3.75h10.5A3.75 3.75 0 0 0 21 18.75zm-3 11.25H6v-1.5h12zm0-3H6V12h12zm0-3H6V9h12z" />
      </svg>
    ),
  },
  {
    label: "New",
    href: "/inventory?condition=New",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M19.5 13.5a1.48 1.48 0 0 1-.977 1.4l-4.835 1.787-1.782 4.84a1.493 1.493 0 0 1-2.801 0l-1.792-4.84-4.84-1.78a1.492 1.492 0 0 1 0-2.802l4.84-1.793 1.78-4.839a1.493 1.493 0 0 1 2.802 0l1.793 4.84 4.839 1.78A1.48 1.48 0 0 1 19.5 13.5m-5.25-9h1.5V6a.75.75 0 1 0 1.5 0V4.5h1.5a.75.75 0 0 0 0-1.5h-1.5V1.5a.75.75 0 1 0-1.5 0V3h-1.5a.75.75 0 1 0 0 1.5m8.25 3h-.75v-.75a.75.75 0 1 0-1.5 0v.75h-.75a.75.75 0 1 0 0 1.5h.75v.75a.75.75 0 1 0 1.5 0V9h.75a.75.75 0 0 0 0-1.5" />
      </svg>
    ),
  },
  {
    label: "Used",
    href: "/inventory?condition=Foreign%20used,Locally%20used",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M22.5 9.75h-1.012l-2.605-5.86a1.5 1.5 0 0 0-1.37-.89H6.486a1.5 1.5 0 0 0-1.37.89L2.513 9.75H1.5a.75.75 0 0 0 0 1.5h.75v7.5a1.5 1.5 0 0 0 1.5 1.5H6a1.5 1.5 0 0 0 1.5-1.5V18h9v.75a1.5 1.5 0 0 0 1.5 1.5h2.25a1.5 1.5 0 0 0 1.5-1.5v-7.5h.75a.75.75 0 1 0 0-1.5m-15 4.5H5.25a.75.75 0 1 1 0-1.5H7.5a.75.75 0 1 1 0 1.5m11.25 0H16.5a.75.75 0 1 1 0-1.5h2.25a.75.75 0 1 1 0 1.5M4.154 9.75 6.488 4.5h11.024l2.334 5.25z" />
      </svg>
    ),
  },
  {
    label: "Vans",
    href: "/inventory?bodyType=Van",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m23.82 10.012-4.27-4.975A1.5 1.5 0 0 0 18.4 4.5H3A1.5 1.5 0 0 0 1.5 6v10.5A1.5 1.5 0 0 0 3 18h1.594a3 3 0 0 0 5.812 0h4.688a3 3 0 0 0 5.812 0H22.5a1.5 1.5 0 0 0 1.5-1.5v-6a.75.75 0 0 0-.18-.488M3 9.75V6h5.25v3.75zm4.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m7.5-9H9.75V6H15zm3 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-1.5-9V6h1.9l3.218 3.75z" />
      </svg>
    ),
  },
  {
    label: "SUVs",
    href: "/inventory?bodyType=SUV",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M22.5 10.5h-2.69l-4.06-4.06A1.5 1.5 0 0 0 14.69 6H4.15a1.5 1.5 0 0 0-1.245.668l-2.78 4.166A.76.76 0 0 0 0 11.25v4.5a1.5 1.5 0 0 0 1.5 1.5h1.594a3 3 0 0 0 5.812 0h6.188a3 3 0 0 0 5.812 0H22.5a1.5 1.5 0 0 0 1.5-1.5V12a1.5 1.5 0 0 0-1.5-1.5m-18.349-3H14.69l3 3H2.156zM6 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
      </svg>
    ),
  },
  {
    label: "Hybrids",
    href: "/inventory?fuelType=Hybrid",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M22.594 6.53 20.78 4.72a.75.75 0 1 0-1.062 1.06l1.812 1.814c.14.14.218.33.219.528v7.628a.75.75 0 1 1-1.5 0V12A2.25 2.25 0 0 0 18 9.75h-1.5v-4.5A2.25 2.25 0 0 0 14.25 3h-7.5A2.25 2.25 0 0 0 4.5 5.25V19.5H3A.75.75 0 1 0 3 21h15a.75.75 0 1 0 0-1.5h-1.5v-8.25H18a.75.75 0 0 1 .75.75v3.75a2.25 2.25 0 0 0 4.5 0V8.122a2.24 2.24 0 0 0-.656-1.591m-9.897 5.751-1.5 3.75a.751.751 0 0 1-1.394-.562l1.089-2.719H9a.75.75 0 0 1-.697-1.031l1.5-3.75a.751.751 0 1 1 1.394.562l-1.089 2.719H12a.75.75 0 0 1 .697 1.031" />
      </svg>
    ),
  },
  {
    label: "Big boot",
    href: "/inventory",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M16.5 3c-1.932 0-3.589 1.702-4.5 4.298C11.089 4.702 9.432 3 7.5 3c-2.944 0-5.25 3.953-5.25 9s2.306 9 5.25 9c1.932 0 3.589-1.703 4.5-4.298.911 2.595 2.568 4.298 4.5 4.298 2.944 0 5.25-3.953 5.25-9s-2.306-9-5.25-9m-6.476 14.474C9.322 18.761 8.402 19.5 7.5 19.5s-1.822-.739-2.524-2.026a9.8 9.8 0 0 1-.96-2.74 3 3 0 1 0 0-5.468c.183-.956.506-1.88.96-2.74C5.678 5.239 6.598 4.5 7.5 4.5s1.822.739 2.524 2.026c.79 1.45 1.226 3.394 1.226 5.474s-.436 4.025-1.226 5.474m9 0c-.702 1.287-1.622 2.026-2.524 2.026s-1.822-.739-2.524-2.026a9.8 9.8 0 0 1-.96-2.74 3 3 0 1 0 0-5.468 9.8 9.8 0 0 1 .96-2.74C14.678 5.239 15.598 4.5 16.5 4.5s1.822.739 2.524 2.026c.79 1.45 1.226 3.394 1.226 5.474s-.436 4.025-1.226 5.474" />
      </svg>
    ),
  },
  {
    label: "Below KSh 3M",
    href: "/inventory?priceMax=3000000",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m21.188 8.258-.118-.282a8.24 8.24 0 0 0-2.828-3.468h2.008a.75.75 0 1 0 0-1.5H10.5A8.26 8.26 0 0 0 2.276 10.6 3 3 0 0 0 0 13.5a.75.75 0 1 0 1.5 0 1.5 1.5 0 0 1 .803-1.328 8.2 8.2 0 0 0 2.01 4.536l1.177 3.296A1.5 1.5 0 0 0 6.904 21h1.192a1.5 1.5 0 0 0 1.413-.996l.18-.504h5.372l.18.504a1.5 1.5 0 0 0 1.413.996h1.192a1.5 1.5 0 0 0 1.413-.996l1.52-4.254H21a2.25 2.25 0 0 0 2.25-2.25v-3a2.25 2.25 0 0 0-2.062-2.242M14.25 6.75H10.5a.75.75 0 1 1 0-1.5h3.75a.75.75 0 1 1 0 1.5M16.875 12a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25" />
      </svg>
    ),
  },
];

export default function BrowseByFilters() {
  return (
    <nav
      className="browse-by-filters"
      aria-label="Browse cars by filters"
    >
      {filters.map((filter) => (
        <Link
          key={filter.label}
          to={filter.href}
          className="browse-by-filters__link"
        >
          <span className="browse-by-filters__icon">
            {filter.icon}
          </span>

          <span>{filter.label}</span>
        </Link>
      ))}
    </nav>
  );
}

